export default __webpack_public_path__ + "dea333154a0750f69e8df8340debf06e.png";